export default "__VITE_ASSET__CLCFV5Rf__"